import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CLASS_ACTIVE, CLASS_EMPTY } from '../../../shared-third-party/consts';
import { Subject } from 'rxjs';
import { ISimpleSearchResult, ISimpleSearchResultDataItem, SearchService } from '../search.service';
import { AnyKeyAnyType } from '../../../shared-third-party/common.type';
import { environment } from '../../../../environments/environment';
import { debounceTime, filter, switchMap, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-simple-search',
  templateUrl: './simple-search.component.html',
  styleUrl: './simple-search.component.scss'
})
export class SimpleSearchComponent implements OnInit {
  @Input() searchClass = CLASS_EMPTY;
  searchForm = new FormGroup({
    query: new FormControl(null, [Validators.required, Validators.minLength(3)]),
  });

  searchResult: ISimpleSearchResult | null = null;
  autoCompleteClass = '';
  private unsubscribe$ = new Subject();

  constructor(private searchService: SearchService) {
  }
  ngOnInit(): void {
    this.searchForm.valueChanges.pipe(
      filter((changes: AnyKeyAnyType) => !!changes && changes['query'].length > 3),
      debounceTime(500),
      switchMap((changes: AnyKeyAnyType) => {
        return this.searchService.getNewBuildingsLocation(changes);
      }),
      takeUntil(this.unsubscribe$),
    ).pipe(
      filter((res: ISimpleSearchResult) => !!res && res.data.length > 0),
      takeUntil(this.unsubscribe$),
    ).subscribe((result: ISimpleSearchResult) => {
      this.searchResult = result;
      this.autoCompleteClass = CLASS_ACTIVE;
    })
  }

  hasSearchTips(data: ISimpleSearchResultDataItem[]|undefined): boolean {
    if (data) {
      return data.length > 0;
    }
    return false;
  }

  getSearchTipUrl(value: string): string {
    return environment.baseUrl + '/novostrojki/zhk/' + value;
  }
}
